import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//默认样式reset
import '@/assets/css/reset.css'
import '@/assets/css/icon.css'
import rem from '@/rem'
import * as ajax from '@/request'
import clipboard from 'clipboard';
// vant
import Vant from 'vant'
import 'vant/lib/index.css'
import { registerGlobalFilters } from './utils/filters'

const app = createApp(App)
app.use(Vant)
app.config.globalProperties.$http = ajax
app.config.globalProperties.globaldata = {}
app.config.globalProperties.clipboard = clipboard

router.beforeEach((to, from, next) => {
  if (to.meta.isAuthRequired === true) {
    if (window.sessionStorage.getItem("Token")) {
      next()
      return
    } else {
      next({
        name: 'Login',
        params: {
          from: to.path
        }
      })
      return
    }
  }
  next()
})

registerGlobalFilters(app)
app.use(router)
app.mount('#app')
